<template>
  <div class="agreement">
    <header class="header">
      <span> {{ agreementType }} </span>
      <div @click="cancelPopup">
        <img src="~@/assets/images/cancel_1.jpeg" alt="" class="cancel" style="width: 0.64rem; height: auto" />
      </div>
    </header>
    <component :is="content" :name="name"  />
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: 'XXX',
    },
    agreementType: {
      type: String,
      default: '入网协议',
    },
  },
  data() {
    return {}
  },
  components: {
    ruwangxieyi: () => import('./content/ruwangxieyi'),

    zhongguoliantongyonghuyinsi: () => import('./content/zhongguoliantongyonghuyinsi'),
  },
  computed: {
    content() {
      const { agreementType } = this
      if (agreementType == `入网协议`) {
        return `ruwangxieyi`
      }else if(agreementType == `中国联通用户隐私政策`){
        return `zhongguoliantongyonghuyinsi`
      }
    },
  },
  methods: {
    cancelPopup() {
      this.$emit('cancelPopup', false)
    },
  },
  mounted(){
  }
}
</script>
<style lang="scss" scoped>
.agreement {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    height: 62px;
    // width: calc(100% - 30px);
    background: #f9f9f9;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #333333;
      letter-spacing: 1.14px;
    }
  }
  .bodyAgreement {
    padding: 10px;
    font-size: 14px;
    .title {
      text-align: center;
    }
  }
}
</style>
